// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__SW0hx","brand":"Navbar_brand__Ey0qM","logo":"Navbar_logo__ZvStZ","brandTitle":"Navbar_brandTitle__tPJ6-","activeLink":"Navbar_activeLink__8gVp6"};